/**
 * The background: the crossing, drawn as a line.
 *
 * Outline only, one stroke colour (`--sea`) at low opacity, behind every card.
 * It is there to make the app feel like the trip it sells — the cards keep their
 * solid surface, so nothing on top ever has to compete with it for contrast.
 *
 * Decorative: `aria-hidden`, no pointer events, and the motion stops under
 * `prefers-reduced-motion`. It is one inline SVG with no requests, so it costs
 * nothing on a phone on one bar of signal at the dock.
 *
 * Composed toward the middle on purpose. `xMidYMax slice` crops the sides on a
 * phone, so the ferry and the lighthouse sit where a narrow screen still has them.
 */
export default function Seascape() {
  return (
    <div className="seascape" aria-hidden="true">
      <svg viewBox="0 0 1440 900" preserveAspectRatio="xMidYMax slice" fill="none"
        stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">

        {/* Sun, high and to the right. */}
        <g className="sea-sun">
          <circle cx="1010" cy="250" r="46" />
          <circle cx="1010" cy="250" r="64" strokeDasharray="2 10" />
        </g>

        {/* Gulls. */}
        <g className="sea-gulls">
          <path d="M610 230q12-12 24 0q12-12 24 0" />
          <path d="M680 200q9-9 18 0q9-9 18 0" />
          <path d="M840 280q8-8 16 0q8-8 16 0" />
        </g>

        {/* Clouds. */}
        <path d="M300 300h150a26 26 0 0 0-30-34a40 40 0 0 0-74 6a22 22 0 0 0-46 28" />
        <path d="M1150 170h120a22 22 0 0 0-26-28a32 32 0 0 0-60 4a18 18 0 0 0-34 24" />

        {/* Vieques: a long low island, the Punta Mulas lighthouse on its point. */}
        <path d="M120 590c60-34 130-58 220-62c80-4 140 18 220 22c70 4 110-8 150 4c26 8 40 22 60 36" />
        <g className="sea-light">
          <path d="M610 552v-58h22v58M606 494h30M612 494l9-14l9 14M621 470v-4" />
          <path d="M638 478l60-14M638 486l60 14" strokeDasharray="3 7" />
        </g>
        {/* Palms on the Vieques shore. */}
        <path d="M250 562c2-26 6-44 16-60M266 502c-12-12-30-12-42-2M266 502c8-12 26-14 38-4M266 502c-16 2-28 10-32 22M266 502c16 2 26 10 30 22" />
        <path d="M420 552c1-20 4-34 12-46M432 506c-10-9-23-9-32-1M432 506c6-9 20-11 29-3M432 506c-12 2-21 8-24 17M432 506c12 2 20 8 23 17" />

        {/* Culebra: smaller, hillier, further off. */}
        <path transform="translate(-250 0)" d="M1060 590c24-26 52-42 82-40c22 2 32 18 52 18c24 0 40-22 66-20c32 2 54 22 70 42" />

        {/* The ferry, out to the right: the content column covers the middle on
            a wide screen, and a ferry nobody can see is not decoration. */}
        <g transform="translate(330 0)">
          <g className="sea-ferry">
            <path d="M760 612h250l-26 40H790z" />
            <path d="M800 612v-34h150v34M830 578v-24h80l18 24" />
            <path d="M820 596h14M850 596h14M880 596h14M910 596h14" />
            <path d="M870 554v-20M870 534l22 8l-22 8" />
            <path d="M1000 640c30 0 40 8 70 8M990 652c24 0 36 6 60 6" strokeDasharray="4 8" />
          </g>
        </g>

        {/* The sea: three swells, each drifting at its own pace. */}
        <g className="sea-waves">
          <path className="wave w1" d="M-200 660q60-16 120 0t120 0t120 0t120 0t120 0t120 0t120 0t120 0t120 0t120 0t120 0t120 0t120 0t120 0t120 0t120 0" />
          <path className="wave w2" d="M-200 720q80-20 160 0t160 0t160 0t160 0t160 0t160 0t160 0t160 0t160 0t160 0t160 0t160 0t160 0t160 0" />
          <path className="wave w3" d="M-200 790q100-24 200 0t200 0t200 0t200 0t200 0t200 0t200 0t200 0t200 0t200 0t200 0t200 0" />
        </g>

        {/* A compass rose, faint, in the lower corner — a chart, not a map. */}
        <g className="sea-rose" transform="translate(180 790)">
          <circle r="38" />
          <path d="M0-56L8-8L56 0L8 8L0 56L-8 8L-56 0L-8-8z" />
          <path d="M0-56v112M-56 0h112" strokeDasharray="2 6" />
        </g>
      </svg>
    </div>
  )
}
